import leftsidechat from "../../asset/Home/leftCard.svg";
import { motion } from "framer-motion";
// import rightsidechat from "../../asset/Home/rightCard.svg";
import logoVideo from "../../asset/Home/AI_LOGO.mp4";
import mouseClick from "../../asset/Home/mouse_click.svg";
import language from "../../asset/Home/language.svg";
import tabs from "../../asset/Home/tabs.svg";
import curveLine from "../../asset/Home//HowItWoksCurv.svg";
import recruitmentIcon from "../../asset/Home//recuritment&HR.svg";
import customerIcon from "../../asset/Home//Customer-Support-Human.svg";
import bankingIcon from "../../asset/Home//Banking&Fintech.svg";
import healthcareIcon from "../../asset/Home//Healthcare.svg";
import gamingIcon from "../../asset/Home//Game.svg";
import logisticIcon from "../../asset/Home//logistic.svg";
import edtechIcon from "../../asset/Home//edtech.svg";
const industries = [
  {
    icon: recruitmentIcon,
    text: "Recruitment & HR",
  },
  {
    icon: customerIcon,
    text: "Customer Support",
  },
  {
    icon: bankingIcon,
    text: "Banking & FinTech",
  },
  {
    icon: healthcareIcon,
    text: "Healthcare & Clinics",
  },
  {
    icon: gamingIcon,
    text: "Gaming & Entertainment",
  },
  {
    icon: logisticIcon,
    text: "Logistics & Delivery Services",
  },
  {
    icon: edtechIcon,
    text: "EdTech & Online Learning",
  },
];
const positionClasses = {
  left1: `
    left-[0%] top-[5%]
    md:left-[-3%] md:top-[-3%]
    lg:left-[4%] lg:top-[12%]
    xl:left-[4%] xl:top-[-2%]
  `,

  left2: `
    left-[-2%] top-[13%]
    md:left-[-2%] md:top-[4%]
    lg:left-[10%] lg:top-[18%]
    xl:left-[7%] xl:top-[3%]
  `,

  left3: `
    left-[0%] top-[22%]
    md:left-[-3%] md:top-[11%]
    lg:left-[13%] lg:top-[26%]
    xl:left-[3%] xl:top-[8%]
  `,

  left4: `
    left-[0%] top-[30%]
    md:left-[-2%] md:top-[18%]
    lg:left-[12%] lg:top-[34%]
    xl:left-[7%] xl:top-[13%]
  `,

  center: `
    left-[38%] top-[15%]
    md:left-[42%] md:top-[13%]
    lg:left-[42%] lg:top-[15%]
    xl:left-[45%] xl:top-[13%]
  `,

  right1: `
  left-[52%] top-[60%]
  md:left-[60%] md:top-[70%]
  lg:left-[57%] lg:top-[67%]
  xl:left-[60%] xl:top-[65%]
`,

right2: `
  left-[49%] top-[68%]
  md:left-[58%] md:top-[77%]
  lg:left-[54%] lg:top-[73%]
  xl:left-[58%] xl:top-[70%]
`,

right3: `
  left-[51%] top-[76%]
  md:left-[62%] md:top-[84%]
  lg:left-[56%] lg:top-[79%]
  xl:left-[60%] xl:top-[75%]
`,

right4: `
  left-[50%] top-[84%]
  md:left-[60%] md:top-[91%]
  lg:left-[55%] lg:top-[85%]
  xl:left-[58%] xl:top-[80%]
`,
};
const tags = [
  {
    text: "Consent - first",
    position: "left1",
    delay: 0,
  },
  {
    text: "One Upload",
    position: "left2",
    delay: 0.1,
  },
  {
    text: "Owner only access",
    position: "left3",
    delay: 0.2,
  },
  {
    text: "Voice Encrypted",
    position: "left4",
    delay: 0.3,
  },
  {
    text: "Cloning in process",
    position: "center",
    delay: 0.7,
  },
  {
    text: "Identity",
    position: "right1",
    delay: 0.6,
  },
  {
    text: "Accent Capture",
    position: "right2",
    delay: 0.7,
  },
  {
    text: "Multilingual",
    position: "right3",
    delay: 0.7,
  },
  {
    text: "Emotion",
    position: "right4",
    delay: 0.7,
  },
];
function HowItWorks() {
  return (
    <>
       <section className="py-12 md:py-16 lg:py-20 px-4 sm:px-6 overflow-hidden">
      <div className="max-w-[1440px] mx-auto">
        {/* Badge */}

        <div className="flex justify-center">
          <span
            className="
							bg-[#FFE4DE]
							text-[#F06A50]
							font-semibold
							text-sm
							font-prompt
							px-2
							py-1
							rounded-md
						"
          >
            How It Works
          </span>
        </div>

        {/* Heading */}

        <h2
          className="
    relative
    z-[100]

    mt-7
    text-center

    font-prompt
    font-bold

    text-[#46453D]

   text-[22px]
sm:text-[28px]
md:text-[40px]
lg:text-[48px]

    leading-[1.1]
    max-w-[860px]
    mx-auto
"
        >
         Turn Your Voice Into an AI Workforce
       
        </h2>

        {/* Illustration */}

<div
  className="
    hidden md:block

    mt-5
    lg:-mt-7

    relative

    h-[420px]
    lg:h-[560px]

    z-0

    md:scale-[0.855]
    lg:scale-[0.855]
    xl:scale-100

    origin-top
  "
>
          {/* Center Glow */}

          <div
            className="
    absolute
    left-1/2
    top-1/2
    -translate-x-1/2
    -translate-y-1/2

    w-[280px]
    h-[280px]

    sm:w-[340px]
    sm:h-[340px]

    md:w-[480px]
    md:h-[480px]

    lg:w-[590px]
    lg:h-[590px]

    rounded-full
    z-0
  "
          >
            <div
              className="
      absolute
      inset-0
      rounded-full
      bg-[#FFE8A8]
      blur-[120px]
      opacity-50
    "
            />

            <div
              className="
      absolute
      top-[20%]
      left-[15%]

      w-[180px]
      h-[180px]

      rounded-full

      bg-[#FFB4A7]
      blur-[90px]

      opacity-40
    "
            />

            <div
              className="
      absolute
      bottom-[15%]
      right-[10%]

      w-[150px]
      h-[150px]

      rounded-full

      bg-[#FFE47A]
      blur-[80px]

      opacity-40
    "
            />
          </div>
          <div
            className="
    absolute
    left-1/2
    top-1/2

    -translate-x-1/2
    -translate-y-1/2

    z-30
  "
          >
            {/* CENTER AI AREA */}
            <div
              className="
    absolute
    left-1/2
    top-1/2

    -translate-x-1/2
    -translate-y-1/2

    z-30
  "
            >
              {/* GLOW */}
              <div
                className="
      absolute
      left-1/2
      top-1/2

      -translate-x-1/2
      -translate-y-1/2

      w-[260px]
      h-[260px]

      sm:w-[380px]
      sm:h-[380px]

      md:w-[520px]
      md:h-[520px]

      lg:w-[650px]
      lg:h-[650px]

      rounded-full

      bg-[radial-gradient(circle,#FFE7D2_0%,transparent_70%)]

      opacity-70

      blur-[20px]

      z-0
    "
              />
              {/* OUTER CIRCLE */}
              <div
                className="
    absolute
    left-1/2
    top-1/2

    -translate-x-1/2
    -translate-y-1/2

 w-[180px]
h-[180px]

sm:w-[260px]
sm:h-[260px]

md:w-[500px]
md:h-[500px]
    lg:w-[579px]
    lg:h-[579px]

    rounded-full

    bg-[#FFEFED]
    opacity-30

    shadow-[-5px_4px_28px_rgba(0,0,0,0.10)]

    z-[5]
  "
              />
              {/* INNER CIRCLE */}
              <div
                className="
    absolute
    left-1/2
    top-1/2

    -translate-x-1/2
    -translate-y-1/2

  w-[110px]
h-[110px]

sm:w-[160px]
sm:h-[160px]

md:w-[290px]
md:h-[290px]


    lg:w-[380px]
    lg:h-[380px]

    rounded-full

    bg-[#FFEFED]
opacity-80
    shadow-[0_20px_50px_rgba(0,0,0,0.06)]

    z-10
  "
              />
              {/* VIDEO ORB */}
              <div
                className="
    absolute
    left-1/2
    top-1/2

    -translate-x-1/2
    -translate-y-1/2

  w-[70px]
h-[70px]

sm:w-[90px]
sm:h-[90px]

md:w-[170px]
md:h-[170px]

    lg:w-[220px]
    lg:h-[220px]

    rounded-full
    overflow-hidden

    bg-white

    shadow-[0_20px_60px_rgba(0,0,0,0.12)]

    z-30
  "
              >
                <video
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="
      w-full
      h-full
      object-cover
      scale-[1.88]
    "
                >
                  <source src={logoVideo} type="video/mp4" />
                </video>
              </div>
            </div>
          </div>

<motion.img
  src={curveLine}
  alt=""
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  transition={{ duration: 0.8 }}
  className="
    absolute

    hidden md:block

    md:left-[66%]
    md:top-[26%]

    lg:left-[64%]
    lg:top-[24%]


    md:w-[95px]
    lg:w-[130px]
 

    object-contain

    z-20
  "
/>
   <motion.img
  src={curveLine}
  alt=""
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  transition={{ duration: 0.8 }}
  className="
    absolute

    hidden md:block

    md:left-[66%]
    md:top-[50%]

    lg:left-[64%]
    lg:top-[50%]

  

    md:w-[95px]
    lg:w-[130px]


    object-contain

    scale-y-[-1]

    z-20
  "
/>
<div
  className="
    absolute

    hidden md:flex

    flex-col

    md:gap-2
    lg:gap-3

    md:right-[-8%]
    lg:right-[8%]


    md:top-[20%]
    lg:top-[19%]


    z-40
  "
>
{industries.map((item, index) => (
  <motion.div
    key={item.text}
    initial={{
      opacity: 0,
      x: 40,
      scale: 0.9,
    }}
    whileInView={{
      opacity: 1,
      x: 0,
      scale: 1,
    }}
    viewport={{
      once: false,
      amount: 0.35,
    }}
    transition={{
      duration: 0.45,
      delay: index * 0.18,
      ease: "easeOut",
    }}
    whileHover={{
      x: -6,
      scale: 1.02,
      transition: { duration: 0.2 },
    }}
    className="
        relative
      overflow-hidden
      bg-white
      border
      border-[#F95D6166]
      rounded-md
      shadow-md

      flex
      items-center
      gap-3

      lg:px-2
      md:px-3

      lg:py-2
      md:py-1

      min-w-[200px]

      font-prompt
      font-semibold

      text-[#474340]

      lg:text-[13px]
      md:text-[10px]
    "
  >
    <div className="absolute inset-0 overflow-hidden rounded-md pointer-events-none">
  <div
    className="
      absolute
      top-0
      -left-1/2
      h-full
      w-[35%]
      skew-x-[-20deg]
      bg-gradient-to-r
      from-transparent
      via-white/80
      to-transparent
    "
    style={{
      animation: `whiteShimmer 1s ease ${index * 0.25}s`,
    }}
  />
</div>
    <motion.img
      src={item.icon}
      alt=""
      className="lg:w-5 lg:h-5 md:w-5 md:h-5 shrink-0"
      initial={{ rotate: -15, scale: 0 }}
      whileInView={{ rotate: 0, scale: 1 }}
      viewport={{ once: false }}
      transition={{
        delay: index * 0.18 + 0.15,
        duration: 0.35,
      }}
    />

    <motion.span
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: false }}
      transition={{
        delay: index * 0.18 + 0.25,
      }}
    >
      {item.text}
    </motion.span>
  </motion.div>
))}
</div>
          {/* Left Card */}

          <motion.img
            initial={{
              opacity: 0,
              x: -80,
              rotate: -8,
            }}
            whileInView={{
              opacity: 1,
              x: 0,
              rotate: 0,
            }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            src={leftsidechat}
            alt=""
            className="
  absolute

  left-[-2%]
  sm:left-[5%]
  md:left-[-4%]
  lg:left-[3%]

  top-[25%]
  md:top-[15%]

  w-[110px]
  sm:w-[180px]
  md:w-[280px]
  lg:w-[430px]

  z-40
"
          />

          {/* <motion.img
            initial={{
              opacity: 0,
              x: 80,
              rotate: 8,
            }}
            whileInView={{
              opacity: 1,
              x: 0,
              rotate: 0,
            }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            src={rightsidechat}
            alt=""
            className="
  absolute

  right-[-2%]
  sm:right-[5%]
    md:right-[-7%]
  lg:right-[3%]

  top-[25%]
  md:top-[15%]

  w-[110px]
  sm:w-[180px]
  md:w-[300px]
  lg:w-[430px]

  z-40
"
          /> */}
          
          {/* TOP RIGHT TABS */}
          <motion.img
            initial={{ opacity: 0, scale: 0 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.55 }}
            src={tabs}
            alt=""
            className="
  absolute

  top-[12%]
  lg:right-[32%]
  right-[24%]

  w-4
  sm:w-6
  md:w-8

  z-50
"
          />

          {/* BOTTOM LEFT LANGUAGE */}
          <motion.img
            initial={{ opacity: 0, scale: 0 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.9 }}
            src={language}
            alt=""
            className="
  absolute

  bottom-[25%]
  left-[38%]
  md:left-[38%]
  md:top-[78%]
top-[76%]
  w-5
  sm:w-7
  md:w-10

  z-50
"
          />

          {/* CLONING CLICK ICON */}
          <motion.img
            initial={{ opacity: 0, scale: 0 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.65 }}
            src={mouseClick}
            alt=""
            className="
  absolute

  top-[22%]
  left-[58%]
  md:left-[57%]
  md:top-[18%]
  lg:top-[16%]
  lg:left-[55%]

  w-4
  sm:w-5
  md:w-7

  z-50
"
          />
          <div className="absolute inset-0 z-40 pointer-events-none">
            {tags.map((tag, index) => (
              <motion.div
                key={index}
                initial={{
                  opacity: 0,
                  scale: 0,
                  y: 50,
                }}
                whileInView={{
                  opacity: 1,
                  scale: 1,
                  y: 0,
                }}
                viewport={{ once: true }}
                transition={{
                  duration: 0.35,
                  delay: tag.delay,
                }}
                className={`
      absolute
      ${positionClasses[tag.position]}

      bg-[#e76049]
      text-white
      lg:rounded-[5px]
      md:rounded-[4px]
      rounded-[2px]
      font-prompt

      text-[7px]
      sm:text-[9px]
      md:text-[11px]
      lg:text-[12px]
	lg:px-5
      px-1
      sm:px-2

      py-1
      sm:py-1

      shadow-md
      whitespace-nowrap
    `}
              >
                {tag.text}
              </motion.div>
            ))}
          </div>
        </div>

        {/* Bottom Text */}

        <p
          className="
		relative
		z-50

		max-w-[900px]
		mx-auto

		mt-4
		md:-mt-10
		lg:-mt-47

		font-jakarta
		text-center

		text-[#0C0200]

		text-[14px]
		sm:text-[15px]
		lg:text-[16px]

		leading-[1.9]

		px-4
	"
        >
          With Craft Your Agent, upload your voice once, build AI agents tailored to your business, and automate natural conversations across sales, hiring, customer support, and more—all without writing a single line of code.
        </p>
      </div>
    </section>
 <style>{`
@keyframes whiteShimmer{
  0%{
    transform:translateX(-140%);
  }
  100%{
    transform:translateX(180%);
  }
}
`}</style>
    </>
 
  );
}

export default HowItWorks;
